
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningLightSnowShowersNightColour as ObiLightningLightSnowShowersNightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-light-snow-showers-night-colour.js';
 
 
 

 
 export const ObiLightningLightSnowShowersNightColour = createComponent({
   react: React,
   tagName: 'obi-lightning-light-snow-showers-night-colour',
   elementClass: ObiLightningLightSnowShowersNightColourElement,
   events: {
     
   }
  });
 
 